module.exports = __webpack_public_path__ + "img/2d0e7bd.jpg";